import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import LearningDataReport from '../../Reports/LearningDataReport';

export default function LearningDataPage(props) {
	console.log(props);
	return (
		<div>
			<Breadcrumb
				pageName={I18n.t('admin.learning_data')}
				category={I18n.t('admin.reports')}
			/>
			<LearningDataReport
				learning_stats_endpoint={props.learning_stats_endpoint}
				assessment_well_being_endpoint={props.assessment_well_being_endpoint}
				export_datatable_endpoint={props.export_datatable_endpoint}
				export_endpoint={props.export_endpoint}
				report={props.report}
			/>
		</div>
	);
}
